
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.7778 14H8.22222C6.99492 14 6 14.9768 6 16.1818V23.8182C6 25.0232 6.99492 26 8.22222 26H23.7778C25.0051 26 26 25.0232 26 23.8182V16.1818C26 14.9768 25.0051 14 23.7778 14Z","stroke":"#10001F","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M11 14L11 10.7062C11 9.45804 11.5268 8.261 12.4645 7.37841C13.4021 6.49583 14.6739 6 16 6C17.3261 6 18.5979 6.49583 19.5355 7.37841C20.4732 8.261 21 9.45804 21 10.7062V14","stroke":"#10001F","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    